import "babel-polyfill";
import "./libs/slick.js";
import "./libs/infiniteslidev2";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {headerSearch} from "./modules/headerSearch";
import {footerMobileMenu} from "./modules/footerMobileMenu";
import {popups} from "./modules/popups";
import {stickyNav} from "./modules/stickyNav";
import {featuredSlider} from "./modules/featuredSlider";
import {filtersBlock} from "./modules/filtersBlock.js";
import {commentsSlider} from "./modules/commentsSlider.js";
import {mediaQuoteSlider} from "./modules/mediaQuoteSlider.js";
import {lastNewsSlider} from "./modules/lastNewsSlider.js";
import {dataCardsSlider} from "./modules/dataCardsSlider.js";
import {casesSlider} from "./modules/casesSlider.js";
import {resourcesSlider} from "./modules/resourcesSlider.js";
import {accordion} from "./modules/accordion.js";
import {countdown} from "./modules/countdown";
import {latestNewsSlider} from "./modules/latestNewsSlider.js";
import {logosSlider} from "./modules/logosSlider";
import {featuredNewsSlider} from "./modules/featuredNewsSlider";
import {animatedTitle} from "./modules/animatedTitle";
import {animationOnScroll} from "./modules/animationOnScroll";
import {investorsSlider} from "./modules/investorsSlider.js";
import {helpCardsSlider} from "./modules/helpCardsSlider";
import {fixedSectionAnimation} from "./modules/fixedSectionAnimation";
import {replaceDOMElements} from "./modules/replaceDOMElements";
import {tabs} from "./modules/tabs";
import {awardsSlider} from "./modules/awardsSlider";
import {locationsMap} from "./modules/locationsMap";
import {showMorePopular} from "./modules/showMorePopular";
import {graphicHolder} from "./modules/graphicHolder";
import {marketoForms} from "./modules/marketoForms";
import {wistiaPoster} from "./modules/wistiaPoster";
import {logoMask} from "./modules/logoMask";
import {searchForm} from "./modules/searchForm";
import {buttonsLabel} from "./modules/buttonsLabel";
import {scrollTop} from "./modules/scrollTop";
import {anchorNavGolossary} from "./modules/anchorNavGolossary";
import {infoCardsList} from "./modules/infoCardsList";
import {landingPopup} from "./modules/landingPopup";
import {customSelect} from "./modules/customSelect";
import {resetFormFilters} from "./modules/resetFormFilters";
import {tabbedSlider} from "./modules/tabbedSlider";
import {plans} from "./modules/plans";
import {plansAccordion} from "./modules/plansAccordion";


binder({
    bounds: {
        html: [constants, fullHeightPage, buttonsLabel],
        ".header": [stickyHeader, mobileNav, headerSearch],
        ".footer": footerMobileMenu,
        ".featured-slider": featuredSlider,
        ".popup-link": popups,
        ".aside-nav.sticky": stickyNav,
        ".anchor-navigation": anchorNavGolossary,
        ".filters-block": filtersBlock,
        ".comments-slider": commentsSlider,
        ".media-quote-slider": mediaQuoteSlider,
        ".last-news-slider": lastNewsSlider,
        ".data-cards-slider": dataCardsSlider,
        ".cases-slider": casesSlider,
        ".resources-slider": resourcesSlider,
        ".accordion": accordion,
        ".countdown": countdown,
        ".latest-news-slider": latestNewsSlider,
        ".logos-slider": logosSlider,
        ".featured-news-slider": featuredNewsSlider,
        ".animated-title": animatedTitle,
        ".has-animation": animationOnScroll,
        ".investors-slider": investorsSlider,
        ".help-cards": helpCardsSlider,
        ".fixed-animation": fixedSectionAnimation,
        ".awards-section": replaceDOMElements,
        ".tabs-holder": tabs,
        ".awards-slider": awardsSlider,
        ".svg-map-holder": locationsMap,
        ".popular-section": showMorePopular,
        ".graphic-section": graphicHolder,
        ".marketo-create": marketoForms,
        ".video-holder": wistiaPoster,
        ".has-masked-logo": logoMask,
        ".search-form": searchForm,
        '.scroll-top': scrollTop,
        '.info-cards-list': infoCardsList,
        '.landing-popup': landingPopup,
        ".custom-select": customSelect,
        ".filters-form.inline": resetFormFilters,
        ".tabbed-slider": tabbedSlider,
        ".plans-cards": plans,
        ".plans-accordion": plansAccordion,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js